import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { Dialog, DialogContent } from "design-system/atoms/Dialog"
import { BackofficeCompanyCreator } from "modules/backoffice/components/companies/BackofficeCompanyCreator"
import { Route as OrganizationsListRoute } from "routes/_base/_auth/backoffice/organizations/list"

export const Route = createFileRoute("/_base/_auth/backoffice/organizations/list/create")({
  component: RouteComponent,
})

function RouteComponent() {
  const search = OrganizationsListRoute.useSearch()
  const navigate = useNavigate()

  function onClose() {
    navigate({ to: "/backoffice/organizations/list", search })
  }

  return (
    <Dialog open onOpenChange={(open) => !open && onClose()}>
      <DialogContent size="5xl" className="max-h-[90vh] overflow-y-auto">
        <BackofficeCompanyCreator />
      </DialogContent>
    </Dialog>
  )
}
